(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Gun"));
	else if(typeof define === 'function' && define.amd)
		define(["Gun"], factory);
	else if(typeof exports === 'object')
		exports["ShogunCore"] = factory(require("Gun"));
	else
		root["ShogunCore"] = factory(root["Gun"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_gun__) => {
return 